import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { faqs } from "@/mocks/faqs";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <SectionHeading
              align="left"
              eyebrow="常见问题"
              title="你关心的核实问题"
              desc="关于真假鉴定、结论可信度与辟谣机制，这里汇总了读者问得最多的几个问题。"
            />
            <div className="rounded-lg bg-primary-900 text-background-50 p-6 hidden lg:block">
              <h3 className="font-heading text-lg font-bold">还是拿不准？</h3>
              <p className="mt-2 text-sm text-background-100/80 leading-relaxed">
                如果你刷到一条难以判断的在线黑料，可以把原链接与你的疑虑提交给我们，进入人工核查队列。
              </p>
              <a
                href="#contact"
                className="mt-4 inline-flex items-center gap-2 rounded-md bg-accent-500 hover:bg-accent-400 text-primary-950 px-4 py-2 text-sm font-semibold whitespace-nowrap transition-colors"
              >
                <i className="ri-send-plane-line"></i>
                提交线索
              </a>
            </div>
          </div>

          <div className="lg:col-span-3 space-y-3">
            {faqs.map((f, i) => {
              const open = openIndex === i;
              return (
                <div
                  key={f.q}
                  className={`rounded-lg border transition-colors ${
                    open ? "border-primary-300 bg-background-100/70" : "border-background-200 bg-background-50"
                  }`}
                >
                  <button
                    aria-expanded={open}
                    onClick={() => setOpenIndex(open ? null : i)}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <h3 className="font-medium text-foreground-900 text-sm md:text-base leading-snug">
                      {f.q}
                    </h3>
                    <span
                      className={`shrink-0 w-8 h-8 flex items-center justify-center rounded-full transition-colors ${
                        open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      <i
                        className={`${open ? "ri-subtract-line" : "ri-add-line"} text-lg`}
                      ></i>
                    </span>
                  </button>
                  {open && (
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-700">
                      {f.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      </div>
    </section>
  );
}